import React from 'react'
import '../../Questions.css'
import { Link } from 'react-router-dom'
import Navbar from '../../../HomeComponents/Navbar';

export default function SideQSubT() {
    return (
        <>
            <Navbar />
            <nav className="sidenav-slim-sub">
                <ul>
                
                    <li className="side-list"><Link to="/tenth/physics">PHYSICS</Link></li>
                    <li className="side-list"><Link to="/tenth/chemistry">CHEMISTRY</Link></li>
                    <li className="side-list"><Link to="/tenth/biology">BIOLOGY</Link></li>
           
                </ul>
                {/* <img src={analytics} className="a-img" alt="" /> */}
            </nav>
        </>
    )
}
